import React, { useContext } from 'react';
import { Dropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import MainContext from '../../contexts/MainContext';

import { ReactComponent as GearIcon } from '../../img/svg/Actions/Setting.svg';
import { ReactComponent as LogOutIcon } from '../../img/svg/Actions/LogOutBlack.svg';
import { ReactComponent as RefreshIcon } from '../../img/svg/Actions/Refresh.svg';
import { ReactComponent as ProfileIcon } from '../../img/svg/User/ProfileGrey.svg';

const Droplinks = [
  {
    id: 1,
    title: 'Settings',
    link: '/StakeHub/Setting',
    svg: <GearIcon className="me-2" />
  },
  {
    id: 2,
    title: 'Profile',
    link: '/StakeHub/Profile',
    svg: <ProfileIcon className="me-2" />
  },
  { id: 3, title: 'Refresh funds', svg: <RefreshIcon className="me-2" /> },
  { id: 4, title: 'Logout', svg: <LogOutIcon className="me-2" /> }
];

function DropDown({ disconnect = () => {}, picture = '' }) {
  const context = useContext(MainContext);
  const [show, setShow] = React.useState(false);
  const showDropdown = (e) => {
    e.stopPropagation();
    setShow(true);
  };
  const hideDropdown = (e) => {
    e.stopPropagation();
    setShow(false);
  };
  return (
    <div className="drop-down-wrapper" id="content-area">
      <Dropdown
        show={show}
        onMouseEnter={showDropdown}
        onMouseLeave={hideDropdown}
        className="nav-link px-4 py-0 dropcontainer"
      >
        <Dropdown.Toggle className="px-0 py-2" variant="" id="dropdown-basic">
          <img
            src={picture || require('../../img/svg/User/User.svg').default}
            style={{
              height: '30px',
              width: '30px',
              objectFit: 'cover',
              borderRadius: '50%'
            }}
            alt=""
          />
          <span className="ms-3 me-1">My wallet</span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {Droplinks.map((item, index) => (
            <Dropdown.Item
              key={index}
              className="dropdown"
              onClick={() => {
                if (item.id !== 3) context.setWalletSlide(true);
                if (item.id === 4) disconnect();
              }}
            >
              <NavLink
                to={item.link || '/'}
                onClick={(e) => !item.link && e.preventDefault()}
                className="link"
                activeClassName="active-link"
              >
                <div className="icon">{item.svg}</div>
                <div>{item.title}</div>
              </NavLink>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default DropDown;
